// extracted by mini-css-extract-plugin
module.exports = {"categoriesScreen":"CategoriesScreen_categoriesScreen__1zLrP","categoriesListHeading":"CategoriesScreen_categoriesListHeading__7KWmr"};